export var LableMap = {
  remark: "备注",
  discType: "商区类型",
  disc: "商区",
  name: "账号",
  totalNewUser: "本月注册",
  avgVisit: "日均活跃",
  mp: "本月业绩",
  avgARPU: "日均",
  sumAvgARPU: "累计日均",
};
